import {getRandomColor, radToDeg, uuidv4} from "./../common/utils.js"

export default class Websocket {
	CONNECTION_UUID = uuidv4();
	ROOM_ID = "9ad45426-d9f7-4608-a909-236dc8d9e069"; //Room we use for connection
	WALLET_ADDR = ""

	ws = null;
	playerCol = null; //Users random assigned color for objects

	pingTimeout = null;

	skipReset = true;

	handlers = {
		"player_move": null,
		"room_join": null,
		"room_leave": null,
		"player_animation": null,
		"chat_message": null,
		"player_motion_capture": null,
		"custom": null, //do whatever
	}

	constructor(walletAddr, roomID = "9ad45426-d9f7-4608-a909-236dc8d9e069") {
		this.WALLET_ADDR = walletAddr
		this.CONNECTION_UUID = uuidv4();
		this.ROOM_ID = roomID
		this.playerCol = getRandomColor()
	}

	getConnectionUUID() {
		return this.CONNECTION_UUID
	}

	getWalletAddr() {
		return this.WALLET_ADDR
	}

	setWalletAddr(addr) {
		console.log("Websocket: Setting wallet address to " + addr)
		this.WALLET_ADDR = addr
	}

	setRoomID(roomID) {
		console.log("Setting room ID to " + roomID)
		this.ROOM_ID = roomID
	}

	setHandler(event, handler) {
		this.handlers[event] = handler
	}

	isConnected() {
		if (!this.ws)
			return false

		return this.ws.readyState === WebSocket.OPEN
	}

	onMessage(msg) {
		const j = JSON.parse(msg.data);
		// console.log("OnMessage in: ", j);

		if (j.code !== undefined && j.code !== 200) {
			console.error("WS Error: ", j.error);
			return
		}

		if (j.data !== undefined && j.data.hasOwnProperty("data")) {
			j.data = j.data.data
			j.data.token_addr = j.data.token_addr || j.data.user_id
		} else {
			// console.log("Setting token_addr = user_id")
			j.data.token_addr = j.data.token_addr || j.data.user_id
		}
		// console.log("JSON: ", j);

		if (this.handlers[j.action_type])
			this.handlers[j.action_type](j.data)
		else
			console.log("Ignoring event: ", j);

	}


	onOpen() {
		this.onJoin() //Sent join room message
	}

	onJoin() {
		console.log("WS Connected: ", this.CONNECTION_UUID);
		this.wsSend(JSON.stringify({
			action_type: "room_join",
			data: {
				room_id: this.ROOM_ID
			}
		}));
	}

	onLeave() {
		console.log("WS Disconnected!")
		// alert("Disconnected from WS")

		console.log("WS Disconnected: ", this.CONNECTION_UUID);
		this.roomLeave()
	}

	onDisconnect() {
		console.log("WS Disconnected")

		this._disconnectEvent()
	}

	onClose() {
		console.log("WS closed!")
		// alert("Disconnected from WS")

		this._disconnectEvent()
	}

	onError(err) {
		console.error("WS Error: ", err);
		// alert("WS Error: " + err)
	}

	roomLeave() {
		this.wsSend(JSON.stringify({
			action_type: "room_leave",
			data: {
				room_id: this.ROOM_ID
			}
		}));
	}

	connect(device_type) {
		if (this.ws !== null && this.ws !== undefined) {
			console.log("Websocket: Already connected!")
			return
		}

		console.log("Connecting to WS as: ", device_type);
		this.ws = new WebSocket('wss://app.alphabatem.com/ws?device_type=' + device_type.toUpperCase() + '&session=' + this.CONNECTION_UUID);
		// this.ws = new WebSocket('ws://localhost:9093/ws?device_type=' + device_type.toUpperCase() + '&session=' + this.CONNECTION_UUID);
		this.bind();
	}

	setFromExisting(ws, connectionUUID) {
		this.ws = ws
		this.CONNECTION_UUID = connectionUUID
		// this.onOpen()
		console.log("Setting existing WS", connectionUUID, ws)
	}

	bind() {
		// Connection opened
		this.ws.addEventListener('open', (e) => this.onOpen(e));
		this.ws.addEventListener('close', (e) => this.onDisconnect(e));
		this.ws.addEventListener('close', (e) => this.onClose(e));
		this.ws.addEventListener('error', (e) => this.onError(e));
		this.ws.addEventListener('message', (e => this.onMessage(e)));
	}

	unbind() {
		// Connection opened
		this.ws.removeEventListener('open', (e) => this.onOpen(e));
		this.ws.addEventListener('close', (e) => this.onDisconnect(e));
		this.ws.removeEventListener('close', (e) => this.onClose(e));
		this.ws.removeEventListener('error', (e) => this.onError(e));
		this.ws.removeEventListener('message', (e => this.onMessage(e)));
	}

	disconnect() {
		console.log("Disconnecting from WS");
		if (this.ws !== null && this.ws !== undefined)
			this.ws.close();
	}

	wsLocalAdvert(word) {
		this.wsLocalAnimation(word)
	}

	wsLocalAnimation(animation_id) {
		this.wsSend(JSON.stringify({
			action_type: 'player_animation',
			data: {
				animation_id: animation_id
			}
		}))
	}

	wsLocalMove(position, rotation) {
		this.wsSend(JSON.stringify({
			action_type: 'player_move',
			data: {
				position: position,
				rotation: {
					x: radToDeg(rotation.z),
					y: radToDeg(rotation.y),
					z: radToDeg(rotation.x)
				}
			}
		}))
	}

//TODO move to item_place rather than hacky chat_message
	wsLocalItemPlace(position, rotation = {x: 0, y: 0, z: 0}) {
		const placement = Object.assign({}, position)
		placement.r = rotation.y //TODO check
		placement.col = this.playerCol

		this.wsSend(JSON.stringify({
			action_type: 'chat_message',
			data: {
				chat: {
					message: JSON.stringify(placement),
					timestamp: Date.now()
				}
			}
		}))
	}

//TODO move to item_move rather than hacky chat_message
	wsLocalItemMove(uid, translation) {
		const placement = Object.assign({}, translation)
		placement.uid = uid

		this.wsSend(JSON.stringify({
			action_type: 'chat_message',
			data: {
				chat: {
					message: JSON.stringify(placement),
					timestamp: Date.now()
				}
			}
		}))
	}

//TODO move to item_remove rather than hacky chat_message
	wsLocalItemRemove(data) {
		this.wsSend(JSON.stringify({
			action_type: 'chat_message',
			data: {
				chat: {
					message: JSON.stringify(data),
					timestamp: Date.now()
				}
			}
		}))
	}

	wsLocalChat(message) {
		this.wsSend(JSON.stringify({
			action_type: 'chat_message',
			data: {
				chat: {
					message: message,
					timestamp: Date.now()
				}
			}
		}))
	}

	wsSend(msg) {
		if (this.ws !== null && this.ws !== undefined && this.ws.readyState === 1) {
			this.ws.send(msg);
		} else {
			console.warn("WS not connected!", this.ws)
		}
	}

	reset() {
		this.CONNECTION_UUID = uuidv4();
		this.ROOM_ID = "9ad45426-d9f7-4608-a909-236dc8d9e069"; //Room we use for connection
		this.WALLET_ADDR = ""
		this.playerCol = null; //Users random assigned color for objects
		this.pingTimeout = null;
	}

	_disconnectEvent() {
		window.dispatchEvent(new CustomEvent("ws-disconnect"))
	}
}